import React from 'react';
import { OptionButton } from 'AppSrc/core/components/utility/option-button';
import {
  CheckBoxUnchecked,
  CheckBoxChecked,
} from 'AppSrc/core/components/common/svg-icons';
import PropTypes from 'prop-types';

const FlightChangesFilterDisplayName = 'Flight changes';

const CrqListFlightChangesFilter = ({ isSelected, toggleFlight }) => (
  <div className="crq-list-checkbox-filter crq-list-mycrq-filter">
    <h3>Flight changes</h3>
    <OptionButton
      className={`checkbox-option ${
        isSelected ? 'checkbox-option-selected' : ''
      }`}
      onClick={toggleFlight}
      option={FlightChangesFilterDisplayName}
    >
      <div className="svg-container">
        {isSelected ? <CheckBoxChecked /> : <CheckBoxUnchecked />}
      </div>
      {FlightChangesFilterDisplayName}
    </OptionButton>
  </div>
);

CrqListFlightChangesFilter.propTypes = {
  isSelected: PropTypes.bool,
  toggleFlight: PropTypes.func,
};

export { CrqListFlightChangesFilter, FlightChangesFilterDisplayName };
